import { memo } from 'react';
import { TrendingUp } from 'lucide-react';
import { BaseNode, type NodeData } from './BaseNode';

function OpportunityNodeComponent({ data, selected }: { data: NodeData; selected?: boolean }) {
  return <BaseNode data={data} selected={selected} icon={TrendingUp} nodeType="opportunity" />;
}

export const OpportunityNode = memo(OpportunityNodeComponent);
